import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo } from 'react'
import { SharedCampaignContext } from '../../../../../../contexts/Advertiser/SharedCampaignContext'
import { separateThousands, currencyFormat } from '../../../../../../utils/Helper'

export default observer(function ProviderMetrics({ provider }) {
  const { selectedScenario } = useContext(SharedCampaignContext)

  const providerActions = useMemo(() => selectedScenario?.actions.filter(action => action.provider === provider), [provider, selectedScenario, selectedScenario?.actions])
  const influencerCount = useMemo(() => [...new Set(providerActions?.map(action => action.authentication_id))].length, providerActions)
  const grossReach = useMemo(() => providerActions?.reduce((result, action) => result + action.reach, 0), providerActions)
  const netReach = useMemo(() => providerActions?.reduce((result, action) => result + action.action_insight?.reach, 0), providerActions)
  const impression = useMemo(() => providerActions?.reduce((result, action) => result + (action.action_insight?.impressions || action?.action_insight?.story_first_sequence_impressions || 0), 0))
  const totalAdvertiserPrice = useMemo(() => providerActions?.reduce((result, action) => result + action.totalAdvertiserPrice, 0), providerActions)

  return (
    <div className="mb-8">
      <table className="w-full rounded-t-lg overflow-hidden bg-white dark:bg-rb-dark-mode border-separate border-spacing-0 border-t border-r border-l border-b border-border-primary dark:border-rb-dark-mode-lighter">
        <thead>
          <tr>
            <th className="w-1/3 bg-rb-grey dark:bg-rb-dark-mode-lighter border border-border-primary dark:border-rb-dark-mode-lighter"></th>
            <th className="w-1/3 bg-rb-grey dark:bg-rb-dark-mode-lighter text-left font-normal py-4 px-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Actual</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Amount of influencers</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {separateThousands(influencerCount)}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Amount of uploads</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {providerActions?.length}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Gross reach</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {grossReach && separateThousands(grossReach)}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Net reach</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {netReach && separateThousands(netReach)}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Impressions</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
                {impression && separateThousands(impression)}
            </td>
          </tr>
          <tr>
            <td className="text-sm font-bold p-2 border border-border-primary dark:border-rb-dark-mode-lighter dark:text-white">Influencer budget</td>
            <td className="border border-border-primary dark:border-rb-dark-mode-lighter p-2 align-middle dark:text-white">
              {totalAdvertiserPrice && currencyFormat(totalAdvertiserPrice.toFixed(2), '€')}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
})